import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';

export { dateLocaleForLanguage } from './dateLocale';

const stored =
  typeof localStorage !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
const initial = stored === 'en' || stored === 'ru' ? stored : 'ru';

if (typeof document !== 'undefined') {
  document.documentElement.lang = initial;
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ru: { translation: ru },
  },
  lng: initial,
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  showSupportNotice: false,
});

i18n.on('languageChanged', (lng: string) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('i18nextLng', lng);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng.split('-')[0] ?? lng;
  }
});

export default i18n;

export const supportedLocales = ['ru', 'en'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

export function isSupportedLocale(v: string | undefined | null): v is SupportedLocale {
  return v === 'ru' || v === 'en';
}
